import { Button, Box, InputBase } from '@mui/material';
import { styled } from '@mui/system';

import Color from '@tool/color';

const DBox = styled(Box)(() => ({
  position: 'relative',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  width: '140px',
  height: '36px',
  marginLeft: '10px',
  padding: '0 10px',
  borderRadius: '5px',
  backgroundColor: Color.f7,

  '& b': {
    lineHeight: 1,
    fontWeight: 500,
  },
}));

const DInput = styled(InputBase)(() => ({
  width: '100%',
  marginRight: '10px',

  '& input': {
    textAlign: 'end',
    lineHeight: 1,
    color: Color.primary,
    fontFamily: 'Roboto',
    fontWeight: 600,

    '&::placeholder': {
      fontSize: '13px',
      color: Color.da,
    },
  },
}));

export { DBox, DInput };
